(function ($, App, Utils, Components) {
  'use strict';
  
  var logger = new Logger("CarouselNavigator");
  
  Components.create('CarouselNavigator', {
    
    // System variable: it will enable components to be reloaded after ajax call
    Reloadable: true,
    
    Selectors: {
      MainElement: "[data-slick-context]",
      Navigator: "[data-slick-nav]",
      ActiveClass: "active"
    },
    
    
    bindEvents: function (context, navigator) {
      
      var items = navigator.find('> *');
      var carousels = context.find(navigator.data('slickNav'));
      
      items.off("click.carousel-navigator change.carousel-navigator").on("click.carousel-navigator change.carousel-navigator", function (e) {
        e.preventDefault();
        
        var
          self = $(this),
          target = $(e.currentTarget);
        
        
        if (target.is("select") && e.type == "click") {
          return true;
        }
        
        var index = target.is("select") ? target.find("option:selected").index() : items.index(e.currentTarget);
        
        items.removeClass("active");
        self.addClass("active");
        
        carousels.each(function (j, carousel) {
          var $carousel = $(carousel);
          Components.Carousels.goTo($carousel, index);
        });
        
      }).on('keyup.carousel-navigator', function (e) {
        
        if (e.keyCode === 13) {
          var
            self = $(this),
            target = $(e.currentTarget);
          
          var index = target.is("select") ? target.find("option:selected").index() : items.index(e.currentTarget);
          
          items.removeClass("active");
          self.addClass("active");
          
          carousels.each(function (j, carousel) {
            var $carousel = $(carousel);
            Components.Carousels.goTo($carousel, index);
          });
        }
      });
      
      carousels.each(function (j, carousel) {
        $(carousel)
          .on(Components.Carousels.Events.AfterSlide, function (e, slick, index, currentSlide) {
            Components.CarouselNavigator.setClasses(items, index, currentSlide);
            
          }).on(Components.Carousels.Events.BeforeSlide, function (e, slick, currentSlide, nextSlide) {
          items.removeClass('out-to-left out-to-right');
          var max = items.length - 1;
          var current = $(items[currentSlide]);
          var next = $(items[nextSlide]);
          if ((currentSlide < nextSlide && !(currentSlide == 0 && nextSlide == max)) || (nextSlide == 0 && currentSlide == max)) {
            current.addClass('out-to-left');
            next.addClass('in-from-right');
          } else {
            current.addClass('out-to-right');
            next.addClass('in-from-left');
          }
        });
      });
    },
    
    setClasses: function (items, index, currentSlide) {
      
      
      // logger.debug("currentSlide", currentSlide);
      // logger.debug("carouselSetclasses", currentSlide);
      
      if(!$(currentSlide).attr("data-carousel-setclasses") || $(currentSlide).data("carouselSetclasses") === 'true'){
        items.removeClass("active prev next in-from-left in-from-right");
        $(items[index]).addClass('active');
        
        if (items[index - 1]) {
          $(items[index - 1]).addClass('prev');
        }
        
        if (items[index + 1]) {
          $(items[index + 1]).addClass('next');
        }
        
        if (!$(currentSlide).hasClass("js-product-card")) {
          $(items).each(function (idx, elem) {
            if ($(elem).is("select")) {
              $(elem).val($($(elem).find("option")[index]).val());
            }
          });
        }
      }
      
    },
    
    setup: function () {
      $(Components.CarouselNavigator.Selectors.MainElement).each(function (i, el) {
        var
          $this = $(this),
          navigators = $this.find(Components.CarouselNavigator.Selectors.Navigator);
        
        navigators.each(function (j, navigator) {
          Components.CarouselNavigator.bindEvents($this, $(navigator));
        });
      });
      
    },
    
    
    init: function () {
      Components.Carousels.on(Components.Carousels.Events.Init, function (e) {
        logger.d("%s caught, setting up navigator", e.type);
        Components.CarouselNavigator.setup();
      });
      
      Components.Carousels.on(Components.Carousels.Events.SingleInit, function (e, carousel) {
        $(Components.CarouselNavigator.Selectors.Navigator).each(function (i, nav) {
          var
            ctx = $(nav).closest(Components.CarouselNavigator.Selectors.MainElement),
            nav = $(nav),
            carousels = ctx.find(nav.data('slickNav'));
          
          carousels.each(function (j, c) {
            logger.d("%s caught, binding navigator for", e.type, c);
            if ($(c).is(Components.CarouselNavigator.Selectors.MainElement + ' ' + $(nav).data('slickNav'))) {
              Components.CarouselNavigator.bindEvents(ctx, nav);
            }
          });
        });
      });
    }
    
    
  });
  
})(jQuery,
  window.App,
  window.App.Utils,
  window.App.Components
);
